import type { CustomerPortfolioSortKey } from '../api/customerManagerWorkspace.ts';
import type { TableSort } from '../ui/index.ts';

/**
 * Column-sort behaviour shared by the two portfolio tables — the customer
 * manager workbench and the customer pool (#1938). They render different
 * column sets over the same row shape, so the sort semantics live here rather
 * than being written twice.
 */
export type PortfolioSort = TableSort<CustomerPortfolioSortKey>;

/**
 * Which direction a column opens on its first click. Text sorts A→Z; money,
 * counts, risk and timestamps open descending, because "largest" / "newest"
 * is what an operator scans these tables for.
 */
const FIRST_CLICK_DIR: Record<CustomerPortfolioSortKey, 'asc' | 'desc'> = {
  email: 'asc',
  org: 'asc',
  owner: 'asc',
  created_at: 'desc',
  balance: 'desc',
  spend_30d: 'desc',
  requests: 'desc',
  keys: 'desc',
  risks: 'desc',
};

/**
 * Clicking the active column flips it; clicking any other column switches to
 * that column's natural opening direction.
 */
export function nextPortfolioSort(
  current: PortfolioSort | null,
  key: CustomerPortfolioSortKey,
): PortfolioSort {
  if (current !== null && current.key === key) {
    return { key, dir: current.dir === 'asc' ? 'desc' : 'asc' };
  }
  return { key, dir: FIRST_CLICK_DIR[key] };
}
